import { render, staticRenderFns } from "./ReqDetalleComponent.vue?vue&type=template&id=2508f566&scoped=true&"
import script from "./ReqDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./ReqDetalleComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReqDetalleComponent.vue?vue&type=style&index=0&id=2508f566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508f566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
